import React from "react";
import { CellContext } from "@tanstack/react-table";
import { AppContext } from "@/App";
import { PageLockContext } from "@/Components/PageLockProvider";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../ui/dropdown-menu";
import { Check } from "lucide-react";

export const BoolCell = ({ getValue, row: { index }, column: { id }, table }: CellContext<any, unknown>) => {
    const app = React.useContext(AppContext);
    const lock = React.useContext(PageLockContext);
    const editingEnabled = app.applicationUser?.userSettings?.inlineTableEditing ?? false;

    const initialValue = getValue<Boolean>()
    // We need to keep and update the state of the cell normally
    const [value, setValue] = React.useState(initialValue)

    // When the input is blurred, we'll call our table meta's updateData function
    const onBlur = (val: Boolean) => {
        setValue(val);
        table.options.meta?.updateData(index, id, val)
    }

    // If the initialValue is changed external, sync it up with our state
    React.useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    if (app.authLevel !== 3 && !lock.viewOnly && editingEnabled) { // only allow editing for non-viewers
        return (
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <button className="w-full min-h-8">
                        {value ? <Check className="m-auto" /> : ""}
                    </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    <DropdownMenuItem className="w-full min-h-8"
                        onClick={() => {
                            onBlur(false);
                        }} >
                    </DropdownMenuItem>
                    <DropdownMenuItem
                        className="w-full min-h-8"
                        onClick={() => {
                            onBlur(true);
                        }}
                    >
                        <Check className="m-auto" />
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        );
    }
    return <>{value ? <Check className="m-auto" /> : ""}</>
};